import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {Header, Footer, Login, SettingsLink, TaxProfile, LoadIndicator} from '../../components';
import styles from './Settings.pcss';
import settingsActions from '../../actions/settings.actions';
import {InterviewIframe} from '../../components/payout/TaxRecordInterview';
import Maintenance from '../../components/payout/Maintenance';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    settingsState: state.get('settings'),
    influencerState: state.get('influencer').toJS(),
    userState: state.get('user').toJS(),
    taxState: state.get('tax').toJS(),
    configState: state.get('config').toJS()
});
const mapDispatchToProps = dispatch => ({
    getSettings: () => {
        dispatch(settingsActions.getSettings());
    }
});

@connect(
    mapStateToProps,
    mapDispatchToProps
)
class Setting extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        userState: PropTypes.object,
        influencerState: PropTypes.object,
        configState: PropTypes.object,
        settingsState: PropTypes.object,
        taxState: PropTypes.object,
        getSettings: PropTypes.func
    };

    state = {
        form: {}
    };

    componentDidMount() {
        const {isLoggedIn} = this.props.userState.accountInfo;
        if (isLoggedIn) {
            this.props.getSettings();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {settingsState} = nextProps;
        const settingsData = settingsState.toJS();
        if (settingsData.loading) {
            return;
        }
        this.setState({
            form: {
                ...settingsData.profile
            }
        });
    }

    renderTaxprofile = () => {
        const {messages, configState, settingsState, userState, taxState} = this.props;
        const {form} = this.state;
        const {accountManagementUrl} = configState;
        const {accountInfo} = userState;
        const settingsData = settingsState.toJS();
        const {isLoggedIn} = accountInfo;

        return (
            <div className={isLoggedIn ? styles.container : styles.containerLogin}>
                <Login isLoggedIn={isLoggedIn}>
                    <LoadIndicator isLoading={taxState.loading} messages={messages}>
                        <div className={styles.wrapper}>
                            <SettingsLink
                                messages={messages}
                                value={form.slug}
                                sectionData={settingsData.slugOptions}
                                accountManagementUrl={accountManagementUrl}
                            />
                            { taxState.createAble &&  <TaxProfile form={form} messages={messages} /> }
                        </div>
                    </LoadIndicator>
                </Login>
            </div>
        );
    };

    renderTaxInterviewUrl = ({url}) => {
        return (
            <div className={styles.iframeWrapper}>
                <InterviewIframe
                    src={url}
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
                    title="Tax Identity Interview"
                />
            </div>
        );
    };

    render() {
        const {messages, userState, influencerState, configState, taxState} = this.props;
        const {affiliateAccount} = influencerState;
        const {accountInfo} = userState;

        const {epicFooter, payoutMaintenance} = configState;

        const showTabs =
            affiliateAccount &&
            affiliateAccount.status !== 'INIT' &&
            affiliateAccount.status !== 'REJECTED' &&
            affiliateAccount.status !== 'DISABLED' &&
            affiliateAccount.status !== 'PENDING';
        const isActive = affiliateAccount && affiliateAccount.status === 'ACTIVE';

        if (!showTabs && !isActive) {
            return <Header
                messages={messages}
                headerClass={styles.header}
                affiliateAccount={affiliateAccount}
                accountInfo={accountInfo}
                configState={configState}
            />;
        }

        return (
            <>
                <Header
                    messages={messages}
                    headerClass={styles.header}
                    affiliateAccount={affiliateAccount}
                    accountInfo={accountInfo}
                    configState={configState}
                />
                    { payoutMaintenance ? <Maintenance /> : <>
                        {!taxState.taxInterviewUrl ? (
                            <this.renderTaxprofile />
                        ) : (
                            <this.renderTaxInterviewUrl url={taxState.taxInterviewUrl} />
                        )}
                    </> }

                <Footer content={epicFooter} messages={messages} accountInfo={accountInfo} />
            </>
        );
    }
}

export default connect(mapStateToProps)(Setting);
